import React, { memo, FC, useCallback } from 'react'

import { Button } from '@/components/Button/Button'
import { orientation } from '@/constants/focus'
import useStore from '@/store/useStore'
import { UsercentricsActionsProps } from '@/types/componentsPropsTypes'

import { ButtonWrapper } from './styles'
import { UsercentricsLayers } from './Usercentrics'
import {
  onAcceptAllHandler,
  onDenyAllHandler,
  updateServices,
} from './usercentricsUtils'

const UsercentricsActionsRaw: FC<UsercentricsActionsProps> = ({
  activeLayer,
  buttonsLabels,
  servicesDecision,
  tcfUserDecisions,
  setActiveLayer,
}) => {
  const setUsercentricsPopup = useStore(
    (state) => state.common.setUsercentricsPopup,
  )
  const isSecondLayerActive = activeLayer === UsercentricsLayers.SECOND_LAYER
  const fromLayer = isSecondLayerActive ? 2 : 1

  const acceptAllHandler = useCallback(async () => {
    try {
      await onAcceptAllHandler(fromLayer)
      setUsercentricsPopup(false)
    } catch {
      console.error('[Usercentrics] acceptAllServices error')
    }
  }, [fromLayer])

  const denyAllHandler = useCallback(async () => {
    try {
      await onDenyAllHandler(fromLayer)
      setUsercentricsPopup(false)
    } catch {
      console.error('[Usercentrics] denyAllServices error')
    }
  }, [fromLayer])

  const saveHandler = useCallback(async () => {
    try {
      await updateServices(servicesDecision, tcfUserDecisions, fromLayer)
      setUsercentricsPopup(false)
    } catch {
      console.error('[Usercentrics] saveServices error')
    }
  }, [servicesDecision, tcfUserDecisions, fromLayer])

  return (
    <ButtonWrapper
      orientation={orientation.VERTICAL}
      focusId={`actions_${activeLayer}`}
    >
      {buttonsLabels.acceptAll && (
        <Button
          text={buttonsLabels.acceptAll}
          onClick={acceptAllHandler}
          expand
          smallButton
          secondary
        />
      )}
      {buttonsLabels.denyAll && (
        <Button
          text={buttonsLabels.denyAll}
          onClick={denyAllHandler}
          expand
          smallButton
          secondary
        />
      )}
      {isSecondLayerActive && buttonsLabels.save && (
        <Button
          text={buttonsLabels.save}
          onClick={saveHandler}
          expand
          smallButton
        />
      )}
      {!isSecondLayerActive && setActiveLayer && (
        <Button
          text={buttonsLabels.manageSettings || buttonsLabels.showSecondLayer}
          onClick={setActiveLayer}
          expand
          smallButton
        />
      )}
    </ButtonWrapper>
  )
}

export const UsercentricsActions = memo(UsercentricsActionsRaw)
